import { createFileRoute } from '@tanstack/react-router'
import { HRPayrollGate } from '@/components/hr/HRPayrollGate'
import { HRPage, type HRSearch, type HRTab } from '@/components/hr/HRPage'

const TABS: HRTab[] = ['today', 'month', 'people', 'leave', 'advances', 'payroll', 'setup']

function HRRoutePage() {
  const search = Route.useSearch()
  return (
    <HRPayrollGate>
      <HRPage search={search} />
    </HRPayrollGate>
  )
}

const str = (v: unknown, re: RegExp) => (typeof v === 'string' && re.test(v) ? v : undefined)

export const Route = createFileRoute('/admin/hr')({
  validateSearch: (s: Record<string, unknown>): HRSearch => ({
    tab: typeof s.tab === 'string' && (TABS as string[]).includes(s.tab) ? (s.tab as HRTab) : undefined,
    date: str(s.date, /^\d{4}-\d{2}-\d{2}$/),
    month: str(s.month, /^\d{4}-\d{2}$/),
    run: str(s.run, /^[0-9a-f-]{36}$/),
    person: str(s.person, /^[0-9a-f-]{36}$/),
  }),
  component: HRRoutePage,
})
